import { render, staticRenderFns } from "./PlayersRating.vue?vue&type=template&id=7f254b9a&"
import script from "./PlayersRating.vue?vue&type=script&lang=js&"
export * from "./PlayersRating.vue?vue&type=script&lang=js&"
import style0 from "./PlayersRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports